import { Flex } from "@chakra-ui/layout";
import { Alert, AlertDescription, AlertIcon } from "@chakra-ui/react";
import Markdown from "markdown-to-jsx";
import { useEditFormTemplateContext } from "../context";

type Props = {
  id: string;
};
export const ImportError: React.FC<Props> = ({ id }) => {
  const { state } = useEditFormTemplateContext();
  const importErrors = state.get("importErrors").get(id);

  if (importErrors === undefined || importErrors.size === 0) {
    return null;
  }
  return (
    <Flex direction="column" gap="2">
      {importErrors.toArray().map((error) => (
        <Alert status="error" key={error} rounded="md">
          <AlertIcon />
          <AlertDescription>
            <Markdown>{error}</Markdown>
          </AlertDescription>
        </Alert>
      ))}
    </Flex>
  );
};
